// AUTO-GENERATED by scripts/fetch-logos.ts — do not edit by hand.
// Maps each org with a real logo in public/logos/<key>.<ext> to that file's
// extension (svg | png | jpg). Orgs absent here render the acronym badge.
export const ORG_LOGO_EXT: Readonly<Record<string, string>> = {
  "aaid": "svg",
  "aas": "png",
  "abtglobal": "png",
  "acf": "svg",
  "act-alliance": "svg",
  "acted": "svg",
  "action-against-hunger": "svg",
  "actionaid": "svg",
  "acumen": "png",
  "aecf": "png",
  "aerc": "png",
  "afla": "svg",
  "african-parks": "png",
  "african-union": "svg",
  "akf": "png",
  "amazon-frontlines": "png",
  "american-red-cross": "svg",
  "aphrc": "svg",
  "avsi": "png",
  "ayuda-en-accion": "png",
  "bibliotheques-sans-frontieres": "png",
  "bis": "svg",
  "blue-ventures": "png",
  "care": "png",
  "caritas": "svg",
  "carter-center": "svg",
  "cbm-global": "svg",
  "cbm": "svg",
  "cchr": "png",
  "cern": "svg",
  "cesvi": "png",
  "charitywater": "jpg",
  "chemonics": "png",
  "coopi": "svg",
  "cordaid": "png",
  "core-group": "png",
  "core": "png",
  "covaw": "svg",
  "croix-rouge-de-belgique": "png",
  "croix-rouge-francaise": "svg",
  "crs": "png",
  "cruz-roja-espanola": "png",
  "cruz-roja-venezolana": "webp",
  "ctg": "png",
  "danish-red-cross": "png",
  "danmission": "png",
  "dca": "png",
  "dcaf": "png",
  "dimagi": "png",
  "dndi": "png",
  "drc": "png",
  "dt-global": "png",
  "ebrd": "png",
  "eca": "svg",
  "eclac": "svg",
  "eden": "png",
  "educo": "png",
  "esa": "svg",
  "escap": "svg",
  "escwa": "svg",
  "euaa": "png",
  "evidence-action": "svg",
  "fao": "svg",
  "feed-the-children": "svg",
  "fhi360": "svg",
  "field-ready": "png",
  "gain": "png",
  "gcf": "png",
  "geneva-call": "png",
  "german-red-cross": "jpg",
  "girl-effect": "png",
  "givedirectly": "svg",
  "global-communities": "png",
  "global-justice-center": "png",
  "greenpeace": "svg",
  "hd": "jpg",
  "heifer-international": "svg",
  "helen-keller-international": "svg",
  "helpage": "svg",
  "hi": "svg",
  "horizont3000": "jpg",
  "hrw": "svg",
  "humedica": "svg",
  "iaea": "svg",
  "icao": "svg",
  "icj": "svg",
  "icrc": "svg",
  "idb": "svg",
  "idinsight": "png",
  "ifrc": "svg",
  "ilga-world": "png",
  "ilo": "svg",
  "imc": "png",
  "imf": "svg",
  "immap-inc": "png",
  "impact-transforming-natural-resource-management": "svg",
  "inso": "png",
  "intersos": "png",
  "iom": "jpg",
  "ipas": "png",
  "irc": "svg",
  "irmct": "svg",
  "isdb": "svg",
  "ishr": "jpg",
  "islamic-relief": "svg",
  "israaid": "svg",
  "itc": "svg",
  "itu": "svg",
  "jrs": "png",
  "jugend-eine-welt": "jpg",
  "justdiggit-foundation": "png",
  "karam": "webp",
  "la-chaine-de-l-espoir": "jpg",
  "laff": "svg",
  "lumos": "png",
  "mag": "jpg",
  "mcc": "png",
  "mdm": "svg",
  "medair": "svg",
  "medglobal": "png",
  "medicos-del-mundo": "png",
  "mercy-corps": "jpg",
  "msf-holland": "svg",
  "msf-switzerland": "svg",
  "msf": "svg",
  "msi": "png",
  "nef": "jpg",
  "norwegian-red-cross": "svg",
  "norwegian-refugee-council": "svg",
  "np": "png",
  "npa": "jpg",
  "nrc": "svg",
  "nutrition-international": "png",
  "oaf": "jpg",
  "ocha": "svg",
  "oecd": "svg",
  "ohchr": "svg",
  "oneacrefund": "jpg",
  "onecampaign": "svg",
  "opec-fund": "png",
  "oxfam": "svg",
  "path": "png",
  "pbi": "svg",
  "phr": "jpg",
  "pih": "svg",
  "pin": "png",
  "plan-international": "svg",
  "premiere-urgence-internationale": "png",
  "reliefweb": "svg",
  "sard": "jpg",
  "save-the-children": "svg",
  "savethechildren": "svg",
  "second-tree": "png",
  "seed-madagascar": "png",
  "sfl": "png",
  "shofco": "png",
  "si": "png",
  "sif": "png",
  "sightsavers": "png",
  "snv": "svg",
  "solidaridad": "jpg",
  "sos-mediterranee": "svg",
  "sos": "svg",
  "spc": "svg",
  "tdh": "png",
  "tetra-tech": "svg",
  "triangle": "svg",
  "trocaire": "png",
  "uk-med": "png",
  "un-habitat": "svg",
  "un-ponte-per": "jpg",
  "un-secretariat": "svg",
  "unccd": "svg",
  "unctad": "jpg",
  "undp": "svg",
  "undrr": "png",
  "unece": "svg",
  "unep": "svg",
  "unesco": "svg",
  "unfpa": "svg",
  "unhcr": "jpg",
  "unicef": "svg",
  "unicri": "svg",
  "unido": "svg",
  "unodc": "svg",
  "unops": "jpg",
  "unrwa": "svg",
  "unwomen": "svg",
  "upu": "svg",
  "vital-strategies": "png",
  "vsf-germany": "png",
  "war-child": "png",
  "wcs": "svg",
  "weworld": "png",
  "wfp": "svg",
  "whh": "png",
  "who": "svg",
  "wikimedia": "svg",
  "wmo": "png",
  "world-relief": "png",
  "world-vision": "svg",
  "worldbank": "svg",
  "worldvision": "svg",
  "zoa": "png",
};
